import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { coaches as coachesApi } from "../services/api";

const LEVEL_LABEL = {
  beginner:     "初學者",
  intermediate: "中級",
  advanced:     "進階",
  all:          "全程度",
};

export default function HomePage() {
  const navigate = useNavigate();
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  useEffect(() => {
    coachesApi.list()
      .then(setCoaches)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>

      {/* Hero（滿版雪景照） */}
      <section style={{
        position: "relative",
        backgroundImage:
          "linear-gradient(180deg, rgba(18,28,46,.58) 0%, rgba(18,28,46,.40) 45%, rgba(18,28,46,.55) 100%), url(/hero-snow.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center 38%",
      }}>
        <div className="fade-up" style={{ maxWidth: 900, margin: "0 auto", padding: "104px 24px 96px", textAlign: "center" }}>
          <h1 style={{ fontSize: 52, marginBottom: 16, lineHeight: 1.15, color: "#fff", textShadow: "0 2px 24px rgba(0,0,0,.35)" }}>
            找到你的<br /><em>完美滑雪教練</em>
          </h1>
          <p style={{ color: "rgba(255,255,255,.88)", fontSize: 17, maxWidth: 480, margin: "0 auto 28px", textShadow: "0 1px 12px rgba(0,0,0,.3)" }}>
            從初學到進階，所有程度都有專業教練陪你征服雪道
          </p>
          <button
            className="btn"
            style={{ height: 48, padding: "0 32px", fontSize: 16, background: "#fff", color: "var(--ink)", fontWeight: 500, boxShadow: "0 6px 24px rgba(0,0,0,.18)" }}
            onClick={() => navigate("/booking")}
          >
            立即預約課程
          </button>
        </div>
      </section>

      {/* 教練列表 */}
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "48px 24px 64px" }}>
        <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ fontSize: 24 }}>我們的教練</h2>
          <span style={{ color: "var(--muted)", fontSize: 14 }}>
            {!loading && `${coaches.length} 位教練`}
          </span>
        </div>

        {loading && (
          <div style={{ textAlign: "center", padding: 60 }}>
            <span className="spinner" style={{ margin: "0 auto" }} />
          </div>
        )}

        {error && (
          <div style={{
            background: "#FEF2F2", border: "1px solid #FECACA",
            color: "var(--red)", borderRadius: 8, padding: 16,
          }}>
            {error}
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 20 }}>
          {coaches.map((coach, i) => (
            <div
              key={coach.id}
              className="card fade-up"
              style={{
                padding: 24,
                transition: "transform .2s, box-shadow .2s",
                animationDelay: `${i * 0.06}s`,
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,.12)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
            >
              <div style={{
                width: 56, height: 56, borderRadius: "50%",
                background: "var(--ink)", color: "var(--white)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 22, marginBottom: 16,
                overflow: "hidden", flexShrink: 0,
              }}>
                {coach.avatar_url
                  ? <img src={coach.avatar_url} alt={coach.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  : coach.name?.[0]
                }
              </div>

              <h3 style={{ fontSize: 18, marginBottom: 4 }}>{coach.name}</h3>

              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
                {(coach.skill_levels || []).map(lvl => (
                  <span key={lvl} className="badge badge-blue">{LEVEL_LABEL[lvl] || lvl}</span>
                ))}
              </div>

              <p style={{
                color: "var(--muted)", fontSize: 14, marginBottom: 20,
                display: "-webkit-box", WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical", overflow: "hidden",
              }}>
                {coach.bio}
              </p>

              <div style={{ display: "flex", gap: 8 }}>
                <button
                  className="btn btn-primary"
                  style={{ flex: 1, height: 36, fontSize: 13 }}
                  onClick={() => navigate("/booking")}
                >
                  預約課程
                </button>
                <button
                  className="btn"
                  style={{ height: 36, fontSize: 13, padding: "0 14px", border: "1.5px solid var(--stone)" }}
                  onClick={() => navigate(`/coaches/${coach.id}`)}
                >
                  查看資訊
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}